// @core/api/endpoints/localization/delete_glossary_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/localization';

/**
 * Delete glossary entry
 * Deletes a glossary entry.
 */
export async function DeleteGlossaryEntry(
  entry_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/glossary/:entry_id`;
  requestPath = requestPath.replace(':entry_id', encodeURIComponent(entry_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
